export const ERROR_MESSAGES = {
    INVALID_REFRESH_TOKEN: "Invalid or expired refresh token",
  };